module.exports = __webpack_public_path__ + "static/img/Group 831@2x.37ab0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/Group 831@2x.png
// module id = 7iVk
// module chunks = 1